const en = {
    'proposalProject.table.filter_by_title': 'Filter by title',
    'proposalProject.table.filter_by_status': 'Filter by status',
    'proposalProject.table.filter_by_id': 'Filter by ID',
    'proposalProject.table.filter_by_description': 'Filter by description',
    'proposalProject.table.button.requestForProjects': 'Create request for projects',
    'proposalProject.table.button.downloadGuide': 'Download guide',

    'proposalProject.table.id': 'Id',
    'proposalProject.table.owner': 'Owner',
    'proposalProject.table.title': 'Title',
    'proposalProject.table.description': 'Description',
    'proposalProject.table.jira': 'Jira Epic',
    'proposalProject.table.status': 'Status',
    'proposalProject.table.actions': 'Actions',

    'proposalProject.table.modal.delete.phrase': 'Are you sure you want to delete?',
    'proposalProject.table.modal.delete.button.cancel': 'Cancel',
    'proposalProject.table.modal.delete.button.delete': 'Delete',
    'proposalProject.table.modal.delete.title': 'Delete',
    'proposalProject.table.modal.restore.title': 'Restore',
    'proposalProject.table.modal.restore.done': 'Successfully done',

    'proposalProject.messages.success': 'Success',

    'proposalProject.table.modal.restore.button.cancel': 'Cancel',
    'proposalProject.table.modal.restore.button.restore': 'Restore',
    'proposalProject.table.modal.restore.phrase': 'Are you sure you want to restore?',

    'proposalProject.table.modal.close': 'Close',

    'proposalProject.table.filter_by_deleted_not_deleted': 'Not deleted',
    'proposalProject.table.filter_by_deleted_deleted': 'Deleted',
    'proposalProject.table.filter_by_deleted_all': 'All',

    'proposalProject.status.step1': 'User - Step 1',
    'proposalProject.status.step2': 'User - Step 2',
    'proposalProject.status.step3': 'IT - Step 3',
    'proposalProject.status.step4': 'IT - Step 4',
    'proposalProject.status.standby': 'Waiting',
    'proposalProject.status.accepted': 'Accepted',
    'proposalProject.status.refused': 'Refused',
    'proposalProject.status.finished': 'Finished',

    // excels
    'proposalProject.excel.titulo_proyecto': 'Project name',
    'proposalProject.excel.id_proyecto': 'Project code or ID:',
    'proposalProject.excel.fecha_inicio_prevista': 'Planned start date',
    'proposalProject.excel.fecha_finalizacion_prevista': 'Planned end date',
    'proposalProject.excel.resp_proyecto': 'Project manager',
    'proposalProject.excel.proyecto_pertenencia': 'Global project to which it belongs',
    'proposalProject.excel.tipo_iniciativa': 'Type of initiative',
    'proposalProject.excel.texto_otro_iniciativa': 'Other text in PROJECT SUMMARY - TYPE OF INITIATIVE',
    'proposalProject.excel.descripcion_proyecto': 'Project description and objectives',
    'proposalProject.excel.que_incluye': 'What the project includes',
    'proposalProject.excel.que_excluye': 'What the project excludes',
    'proposalProject.excel.departamentos_proyecto': 'Impacted departments',
    'proposalProject.excel.usuarios_impacto': 'Impacted users',
    'proposalProject.excel.nivel_impacto': 'Impact level',
    'proposalProject.excel.tipo_impacto': 'Type of impact',
    'proposalProject.excel.texto_otro_impacto': 'Other text in PROJECT SCOPE AND INVOLVED AREAS - Type of impact',
    'proposalProject.excel.objetivos_proyecto': 'Strategic objectives supported',
    'proposalProject.excel.objetivosOperacionales_proyecto': 'Related operational objectives',
    'proposalProject.excel.exp_si_esfuerzo': 'IT EXPECTATIONS - EFFORT',
    'proposalProject.excel.exp_si_grado_cump': 'IT EXPECTATIONS - DEGREE OF COMPLIANCE',
    'proposalProject.excel.exp_si_impacto': 'IT EXPECTATIONS - IMPACT',
    'proposalProject.excel.exp_negocio_esfuerzo': 'BUSINESS EXPECTATIONS - EFFORT',
    'proposalProject.excel.exp_negocio_grado_cump': 'BUSINESS EXPECTATIONS - DEGREE OF COMPLIANCE',
    'proposalProject.excel.exp_negocio_impacto': 'BUSINESS EXPECTATIONS - IMPACT',
    'proposalProject.excel.exp_negocio_nvl_satis': 'BUSINESS EXPECTATIONS - SATISFACTION LEVEL',
    'proposalProject.excel.val_neg_dpt': 'BUSINESS VALIDATION ROW - Department',
    'proposalProject.excel.val_neg_cargo': 'BUSINESS VALIDATION ROW - Position',
    'proposalProject.excel.val_neg_nombre': 'BUSINESS VALIDATION ROW - Name',
    'proposalProject.excel.val_neg_fecha': 'BUSINESS VALIDATION ROW - Date',
    'proposalProject.excel.val_neg_comentarios': 'BUSINESS VALIDATION ROW - Comments',
    'proposalProject.excel.val_si_cargo': 'IT VALIDATION ROW - Position',
    'proposalProject.excel.val_si_nombre': 'IT VALIDATION ROW - Name',
    'proposalProject.excel.val_si_fecha': 'IT VALIDATION ROW - Date',
    'proposalProject.excel.val_si_comentarios': 'IT VALIDATION ROW - Comments',
};
export default en;